const feature_slider_el = document.querySelectorAll('[id^="feature_slider_"]');

feature_slider_el.forEach(el => {
  const contentSelector = '#' + el.id + ' .slider-content-wrapper .swiper-container';
  const imageSelector = '#' + el.id + ' .slider-wrapper .swiper-container';
  const slideCount = $(contentSelector).data('slide-count');

  let feature_slider_content_el = new Swiper(contentSelector, {
    loop: false,
    autoHeight: true,
    effect: 'fade',
    allowTouchMove: false,
    fadeEffect: {
      crossFade: true
    }
  });

  let feature_slider_image_el = new Swiper(imageSelector, {
    loop: true,
    loopedSlides: slideCount,
    slidesPerView: 'auto',
    spaceBetween: 40,
    centeredSlides: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    preloadImages: true,
    pagination: {
      el: '#' + el.id + ' .slider-content-wrapper .swiper-pagination',
      clickable: true
    },
    navigation: {
      nextEl: '#' + el.id + ' .slider-content-wrapper .swiper-button-next'
    },
    breakpoints: {
      1200: {
        centeredSlides: false
      }
    },
    on: {
      init: function(el) {
        let index = el.activeIndex,
            slide = el.slides[index],
            video = slide.querySelectorAll('video')[0];

        if (video) {
          video.play();
        }

        if (feature_slider_content_el) {
          feature_slider_content_el.slideTo(el.realIndex, 0, false);
        }
      },
      slideChange: function(el) {
        let index = el.activeIndex,
            active_slide = el.slides[index],
            active_video = active_slide.querySelectorAll('video')[0];

        let prev_index = el.previousIndex,
            prev_slide = el.slides[prev_index],
            prev_video = prev_slide.querySelectorAll('video')[0];

        let sc_player = SC.Widget($('iframe.sc-widget')[0]);

        if (prev_video) {
          prev_video.pause();
          prev_video.currentTime = 0;
          // prev_video.load();
        }

        if (active_video) {
          active_video.play();
        }

        if (feature_slider_content_el) {
          feature_slider_content_el.slideTo(el.realIndex);
        }
      }
    }
  });

  // MUTE/UNMUTE BUTTON
  $('.tif-feature-slider span.volume').on('click', function(e) {
    e.preventDefault();

    let video = $(this).closest('.image').find('video');

    $(this).toggleClass('active');
    video.prop('muted', !video.prop('muted'));
  })
});
